module.exports = window["moment"];